import {
  Button,
  Card,
  Dialog,
  Checkbox,
  FormControlLabel,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormGroup,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import ReactDragList from "react-drag-list";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Input, Label } from "reactstrap";
import Axios from "axios";
import { templateActions } from "../../../../store/actions/cms/template/template.action";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddIcon from "@material-ui/icons/Add";
import SubdirectoryArrowRightIcon from "@material-ui/icons/SubdirectoryArrowRight";
import ReplayIcon from "@material-ui/icons/Replay";
import DoneIcon from "@material-ui/icons/Done";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { arrayHelper } from "../../../../helpers/arrayHelper";
const useStyles = makeStyles({
  paper: {
    height: "100%",
  },
});

const MenuEditDialog = (props) => {
  const classes = useStyles();
  const { menu, dispatch, cms } = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const [isSavable, setIsSavable] = useState(false);
  const [deletedList, setDeletedList] = useState([]);
  const [showConfirmDialog, toggleConfirmDialog] = useState(false);

  useEffect(() => {
    if (menu && Array.isArray(menu) && menuItems.length == 0) {
      setMenuItems(menu);
      if (menu.length > 0) {
        let m = null;
        menu
          .filter((x) => !x.parentMenuId)
          .map((x) => {
            if (!m || m.sortOrder > x.sortOrder) {
              m = x;
            }
          });
        if (m) setSelectedItem(m.menuId);
      }
    }
  }, []);

  const onSave = () => {
    const finalMenuItems = Array.from(menuItems.filter((m) => !deletedList.includes(m.menuId)));
    Axios.post("./api/menu?eventId=" + cms.eventId, finalMenuItems).then((res) => {
      dispatch(templateActions.setMenu(res.data));
      toggle(true);
    });
  };
  const onAdd = (id) => {
    const { eventId } = cms;
    
    let menuId = (menuItems.filter((m) => m.menuId <= 0).length + 1) *-1;
    const sortOrder = !id ? menuItems.length + 1 : menuItems.filter((m) => m.parentMenuId == id).length + 1;

    const newOption = {
      menuId,
      oldId: menuId,
      eventId,
      parentMenuId: id,
      languageCode: "swe",
      label: "-",
      url: "",
      sortOrder,
      updatedUserId: null,
      target: "_self",
      appendBadgeNo: true,
      updated: new Date().toISOString(),
      inserted: new Date().toISOString(),
    };
    const newMenuItems = Array.from(menuItems);
    newMenuItems.push(newOption);
    setMenuItems(newMenuItems);
    setIsSavable(true);
    setSelectedItem(menuId);
  };
  const onDelete = (id) => {
    let newDeletedList = Array.from(deletedList);
    if (deletedList.includes(id)) {
      newDeletedList = newDeletedList.filter((dl) => dl != id);
      setDeletedList(newDeletedList);
    } else {
      newDeletedList.push(id);
      setDeletedList(newDeletedList);
    }
    setIsSavable(true);
  };
  const onChange = (path, value) => {
    const newMenuItems = Array.from(menuItems);
    const index = menuItems.indexOf(menuItems.find((m) => m.menuId == selectedItem));
    if (index > -1) {
      newMenuItems[index][path] = value;
      setMenuItems(newMenuItems);
    }
    setIsSavable(true);
  };
  const isDeleted = (id) => deletedList.includes(id);
  const onSelect = (id) => setSelectedItem(id);
  const onSort = (event, dataSource, child = null) => {
    let rest = Array.from(menuItems.filter((r) => r.parentMenuId != null));
    if (child) {
      rest = menuItems.filter((r) => r.parentMenuId != child);
    }
    const sortedOptions = dataSource.map((ds, i) => {
      let el = Object.assign({}, ds);
      el.sortOrder = i + 1;
      return el;
    });

    setMenuItems(arrayHelper.concat(sortedOptions, rest));
    setIsSavable(true);
  };
  const toggle = (surpass = false) => {
    if (isSavable && !showConfirmDialog && !surpass) {
      toggleConfirmDialog(true);
      return;
    }

    dispatch(templateActions.toggleMenuModal());

    if (isSavable && showConfirmDialog) {
      toggleConfirmDialog(false);
    }
  };
  return (
    <>
      {showConfirmDialog ? <ConfirmDialog save={onSave} toggle={toggle} toggleConfirmDialog={toggleConfirmDialog} /> : null}
      <Dialog fullWidth={true} maxWidth={"lg"} open={true} classes={classes} style={{ height: "100%" }} onClose={() => null} aria-labelledby="menu editing dialog">
        <DialogTitle>
          <div className="row">
            <div className="text-left col-4">
              <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => onAdd()}>
                <SystemLabel name="AddMenuOption" />
              </Button>
            </div>
            <div className="text-center col-4">
              <SystemLabel name="MenuEditor" />
            </div>
            <div className="text-right col-4">
              <Button onClick={() => toggle()} color="primary" startIcon={<CloseIcon />}></Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent
          style={{
            overflowY: selectedItem ? "hidden" : undefined,
            overflowX: "hidden",
            height: "100%",
          }}
        >
          <Row style={{ height: "100%" }}>
            <Col style={{ height: "100%" }}>
              <List
                style={{
                  height: "100%",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <ReactDragList
                  animation={10}
                  dataSource={menuItems
                    .filter((m) => m.parentMenuId == null)
                    .sort((a, b) => {
                      return a.sortOrder - b.sortOrder;
                    })}
                  rowKey={"menuId"}
                  className="menu-list"
                  rowClassName="rdl-row"
                  handles={false}
                  onUpdate={(event, dataSource) => onSort(event, dataSource)}
                  row={(m, index) => {
                    return (
                      <div
                      className="smooth-shadow"
                        style={{
                          padding: 10,
                          borderRadius: 5,
                          marginRight: 10,
                          width: "100%",
                          marginBottom: 5,
                          border: "1px solid gainsboro",
                          
                        }}
                      >
                        <MenuItem selectedItem={selectedItem} isDeleted={isDeleted(m.menuId)} onSelect={onSelect} onDelete={onDelete} onAdd={onAdd} eventId={cms.eventId} {...m} />

                        {menuItems.find((mi) => mi.parentMenuId == m.menuId) ? (
                          <ReactDragList
                            animation={10}
                            dataSource={menuItems
                              .filter((c) => c.parentMenuId == m.menuId)
                              .sort((a, b) => {
                                return a.sortOrder - b.sortOrder;
                              })}
                            rowKey={"menuId"}
                            className="menu-list"
                            rowClassName="rdl-row"
                            handles={false}
                            onUpdate={(event, dataSource) => onSort(event, dataSource, m.menuId)}
                            row={(c, index) => {
                              return (
                                <div
                                  style={{
                                    padding: "0 10px",
                                    width: "100%",
                                    // marginBottom: 5,
                                  }}
                                >
                                  <MenuItem selectedItem={selectedItem} isDeleted={isDeleted(c.menuId)} onSelect={onSelect} onDelete={onDelete} onAdd={onAdd} eventId={cms.eventId} {...c} />
                                </div>
                              );
                            }}
                          />
                        ) : null}
                      </div>
                    );
                  }}
                />
              </List>
            </Col>
            {selectedItem != null ? (
              <Col style={{ height: "100%" }}>
                <EditableTab onChange={onChange} {...menuItems.find((mi) => mi.menuId == selectedItem)} />
              </Col>
            ) : null}
          </Row>
        </DialogContent>
        <DialogActions style={{ position: "relative" }}>
          <Button onClick={() => toggle()} color="primary">
            <SystemLabel name="Cancel" />
          </Button>
          {' '}
          <Button disabled={!isSavable} onClick={() => onSave()} style={isSavable ? { backgroundColor: "#4dbd74", color: "white" } : null} variant="contained" startIcon={<SaveIcon />}>
                <SystemLabel name="Save" />
              </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const ConfirmDialog = ({ save, toggle, toggleConfirmDialog }) => {
  return (
    <div>
      <Dialog open={true} onClose={() => null} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          <SystemLabel name="UnsavedChanges" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <SystemLabel name="UnsavedChangesDetails" />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => toggleConfirmDialog(false)} color="primary">
            <SystemLabel name="Cancel" />
          </Button>
          <Button onClick={toggle} color="primary">
            <SystemLabel name="Leave" />
          </Button>
          <Button onClick={save} color="primary" autoFocus>
            <SystemLabel name="Save" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    template: state.template.template,
    menu: state.template.menu,
    eventId: state.template.template.eventId,
    cms: state.cms,
  };
}

export default connect(mapStateToProps)(MenuEditDialog);

const MenuItem = (props) => {
  const { label, url, isDeleted, parentMenuId, onAdd, selectedItem, menuId, onDelete, onSelect } = props;
  let child = parentMenuId;
  return (
    <>
      <ListItem
      
        style={{
          marginLeft: child ? 10 : undefined,
          background: isDeleted ? "gainsboro" : undefined,
          opacity: isDeleted ? 0.4 : 1,
          boxShadow: selectedItem == menuId ? "#3f51b5 0px 0px 4px 2px" : null,
          border: "1px solid gainsboro",
          borderRadius:5,
        }}
      >
        <ListItemText primary={label} />
        <ListItemSecondaryAction style={parentMenuId > 0 ? {right:"-2px"}:null}>
          <IconButton onClick={() => onSelect(selectedItem == menuId ? null : menuId)} edge="end" aria-label="delete">
            {selectedItem == menuId ? <DoneIcon /> : <CreateOutlinedIcon />}
          </IconButton>
          <IconButton onClick={() => onDelete(menuId)} edge="end" aria-label="delete">
            {isDeleted ? <ReplayIcon /> : <DeleteOutlineIcon />}
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      {!child ? (
        <Button
          style={{ marginLeft: 10 }}
          startIcon={
            <>
              <SubdirectoryArrowRightIcon />
              <AddIcon />
            </>
          }
          onClick={() => onAdd(menuId)}
        >
          <SystemLabel name="AddChildToThisOption" />
        </Button>
      ) : null}
    </>
  );
};

const EditableTab = (props) => {
  const { onChange, label, url, eventId, target } = props;
  const [internalPaths, setInternalPaths] = useState([]);
  const [domain, setDomain] = useState([]);
  useEffect(() => {
    getInternalPaths();
  }, []);
  const getInternalPaths = () => {
    if (!eventId) return;
    Axios.get(`./api/link/${eventId}`).then((res) => {
      const { data } = res;
      if (data) {
        const { pathsObj } = data;
        let paths = pathsObj.paths;
        setInternalPaths(paths);
        setDomain(pathsObj.domain);
      }
    });
  };
  const toggleBadgeno = () => {
    let path = url;
    if (path && path.includes("[BadgeNo]")) {
      path = path.replace("badgeNo=[BadgeNo]", "").replace("clientKey=[BadgeNo]", "");
    } else {
      if (path.includes("/register/") || path.includes("/p/")) {
        path = path + "&badgeNo=[BadgeNo]";
      } else if (path.includes("/digitalmeeting/") || path.includes("/digitalarena/") || path.includes("/exhibitor/")) {
        path = path + "&clientKey=[BadgeNo]";
      }
    }
    while (path && (path.includes("?&") || path.includes("&&"))) {
      path = path.replace("?&", "?").replace("&&", "&");
    }
    onChange("url", path);
  };

  const toggleOpenInNewWindow = () => {
    if (target == "_blank") onChange("target", "_self");
    else onChange("target", "_blank");
  };
  const selectPath = (id) => {
    let path = convertPath(id);
    onChange("url", path);
  };
  const convertPath = (id) => {
    const internalPath = internalPaths.find((p) => p.id == id);
    let type = internalPath ? internalPath.type : "";
    if (typeof id == "string" && !isNaN(id)) {
      id = parseInt(id);
    }
    switch (type) {
      case "Form":
        return domain + (!window.location.href.includes("localhost") ? "/cms" : "") + "/register/" + id.toString(36) + "?badgeNo=[BadgeNo]";
      case "Page":
        return domain + (!window.location.href.includes("localhost") ? "/cms" : "") + "/p/" + id.toString(36) + "?badgeNo=[BadgeNo]";
      case "Breakout":
        return domain + (!window.location.href.includes("localhost") ? "/interaction" : "") + "/digitalarena/" + id + "?clientKey=[BadgeNo]";
      case "DigitalArena":
        return domain + (!window.location.href.includes("localhost") ? "/interaction" : "") + "/digitalarena/" + id + "?clientKey=[BadgeNo]";
      case "Exhibitor":
        return domain + (!window.location.href.includes("localhost") ? "/interaction" : "") + "/exhibitor/" + id.toString(36) + "?clientKey=[BadgeNo]";
      case "AnonymousSurvey":
        return domain + (!window.location.href.includes("localhost") ? "/cms" : "") + "/survey/" + id + "?"; /* .toString(36) */
      case "Survey":
        return "[SurveyLink]";
      default:
        return "";
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <FormGroup>
        <Label>
          <SystemLabel name="DisplayText" />
        </Label>
        <Input onChange={(e) => onChange("label", e.target.value)} value={label} />
      </FormGroup>
      <br />
      <FormGroup>
        <Label>
          <SystemLabel name="Url" />
        </Label>
        <Input onChange={(e) => onChange("url", e.target.value)} value={url} />
      </FormGroup>
      <br />
      <FormGroup>
        <FormControlLabel
          label={<SystemLabel name="AppendBadgeno" />}
          control={<Checkbox name="AppendBadgeno" color="uncontrolled" checked={url && url.includes("[BadgeNo]")} onChange={toggleBadgeno} />}
        />
        <FormControlLabel
          label={<SystemLabel name="OpenInNewWindow" />}
          control={<Checkbox name="OpenInNewWindow" color="uncontrolled" checked={target == "_blank"} onChange={toggleOpenInNewWindow} />}
        />
      </FormGroup>
      <br />
      <Label>
        <SystemLabel name="InternalPages" />
      </Label>
      <div className="path-list">
        {internalPaths.map((a, i) => {
          return (
            <Row className="check-g-item" onClick={() => selectPath(a.id)} key={i}>
              <Col className="text-left">{a.name == "Survey" ? <SystemLabel name="ComContentSurvey" /> : a.name}</Col>
              <Col className="text-right type-text">
                <SystemLabel name={a.type} />
              </Col>
            </Row>
          );
        })}
      </div>
    </div>
  );
};
